import type {
    ConfirmUploadRequestBody,
    ConfirmUploadResponse,
    CreateUploadUrlRequestBody,
    CreateUploadUrlResponse,
    GetFileDownloadUrlResponse,
    GetFileListRequestQuery,
    GetFileListResponse,
} from '@engagement-web-app/common';
import { APIError } from './types';

export async function fetchOrganizationFiles(
    organizationId: string,
    { from, limit }: GetFileListRequestQuery
): Promise<GetFileListResponse> {
    try {
        const params = new URLSearchParams();
        if (from !== undefined) params.set('from', String(from));
        if (limit !== undefined) params.set('limit', String(limit));
        const res = await fetch(`/api/system/organizations/${organizationId}/files?${params.toString()}`);
        const data = await res.json();
        if (!res.ok) throw APIError.fromResponse(data);
        return data;
    } catch (error) {
        if (error instanceof APIError) throw error;
        throw APIError.default();
    }
}

export async function createUploadUrl(
    organizationId: string,
    body: CreateUploadUrlRequestBody
): Promise<CreateUploadUrlResponse> {
    try {
        const res = await fetch(`/api/system/organizations/${organizationId}/files/upload-url`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
        });
        const data = await res.json();
        if (!res.ok) throw APIError.fromResponse(data);
        return data;
    } catch (error) {
        if (error instanceof APIError) throw error;
        throw APIError.default();
    }
}

export async function confirmUpload(
    organizationId: string,
    fileId: string,
    body: ConfirmUploadRequestBody
): Promise<ConfirmUploadResponse> {
    try {
        const res = await fetch(`/api/system/organizations/${organizationId}/files/${fileId}/confirm`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
        });
        const data = await res.json();
        if (!res.ok) throw APIError.fromResponse(data);
        return data;
    } catch (error) {
        if (error instanceof APIError) throw error;
        throw APIError.default();
    }
}

export async function fetchFileDownloadUrl(
    organizationId: string,
    fileId: string
): Promise<GetFileDownloadUrlResponse> {
    try {
        const res = await fetch(`/api/system/organizations/${organizationId}/files/${fileId}/download-url`);
        const data = await res.json();
        if (!res.ok) throw APIError.fromResponse(data);
        return data;
    } catch (error) {
        if (error instanceof APIError) throw error;
        throw APIError.default();
    }
}

export async function deleteFile(organizationId: string, fileId: string): Promise<void> {
    try {
        const res = await fetch(`/api/system/organizations/${organizationId}/files/${fileId}`, {
            method: 'DELETE',
        });
        if (!res.ok) {
            const data = await res.json();
            throw APIError.fromResponse(data);
        }
    } catch (error) {
        if (error instanceof APIError) throw error;
        throw APIError.default();
    }
}
